import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=2001dc68&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=2001dc68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2001dc68",
  null
  
)

export default component.exports